import { defineStore } from "pinia";
import { ref } from "vue";

/**
 * Owns UI-only state for the app shell (MainLayout):
 * which rail is collapsed/open, which menu is active.
 * No API calls here — data fetching belongs to feature stores.
 */
export const useLayoutStore = defineStore("layout", () => {
  const sidebarCollapsed = ref(false);
  const mobileSidebarOpen = ref(false);
  const rightPanelVisible = ref(true);
  const activeMenuKey = ref("home");

  const toggleSidebar = () => {
    sidebarCollapsed.value = !sidebarCollapsed.value;
  };

  const openMobileSidebar = () => {
    mobileSidebarOpen.value = true;
  };

  const closeMobileSidebar = () => {
    mobileSidebarOpen.value = false;
  };

  const toggleRightPanel = () => {
    rightPanelVisible.value = !rightPanelVisible.value;
  };

  const setActiveMenu = (key) => {
    activeMenuKey.value = key;
  };

  return {
    sidebarCollapsed,
    mobileSidebarOpen,
    rightPanelVisible,
    activeMenuKey,
    toggleSidebar,
    openMobileSidebar,
    closeMobileSidebar,
    toggleRightPanel,
    setActiveMenu,
  };
});
